import React from 'react';
import { Container } from '@mui/material';

interface IContainerWrapper {
    children: JSX.Element;
}

const ContainerWrapper: React.FC<IContainerWrapper> = ({ children }) => {
    return (
        <Container
            maxWidth={false}
            disableGutters
            sx={{
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                gap: '30px',
                height: '100%',
                width: '100%',
                overflowX: 'hidden',
                minHeight: '100vh',
                marginLeft: { xs: '0px', sm: '65px' },
                paddingTop: { xs: '20px', lg: '0px' },
            }}>
            {children}
        </Container>
    );
};

export { ContainerWrapper };
